import React from 'react'


export default function Copyright({children, ...restProps}) {
    return (
        <div>
            <div sm={4} {...restProps}>{children}</div>
        </div>
    )
}